import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'currency-mismatch-banner',
    template: `
        <div *ngIf="currencies && currencies.length > 1" class="myc-currency-banner">
            <span aria-hidden="true">ℹ</span>
            <span>{{ 'aumico_analytics_currency_mismatch_banner' | i18next: { currencies: currencies.join(', ') } }}</span>
        </div>
    `,
    styleUrls: ['./currency-mismatch-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyMismatchBannerComponent {
    @Input() public currencies: string[] = [];
}
